import React from "react";
import AccountabilityCard from "../../../../parts/cards/profile-accountability";
import submit from "submit-form";
import scriptLoader from "../../../../utils/scriptLoader";
import {
  compareArrays,
  filterAccountabilityAttrs,
  getAccountabilitiesList,
  isEditing,
  isItemFilled,
  isStateFilled,
} from "../../../../utils/daily-accountability";
import ToolTip from "../../../../parts/tooltip-portal";
import moment from "moment";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";
import SvgIcon from "../../../../parts/SvgIcon";

const weekDays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const Accountability = ({
  athlete,
  locals,
  userToLoadInformation,
  organizationCoach,
  organizationOwner,
}) => {
  let days = {};
  weekDays.forEach((day) => (days = { ...days, [day]: false }));
  const newItem = {
    title: "",
    description: "",
    days,
    editing: true,
    adding: true,
  };
  const { query, origin, activeUser } = locals;
  const { athleteSwitch } = query;
  const referAsClients = activeUser?.referAsClients || false;
  const { customAccountability } = athlete;

  const [state, setState] = React.useState(false);
  const [changed, setChanged] = React.useState(false);
  const [adding, setAdding] = React.useState(false);
  const [canSubmit, setCanSubmit] = React.useState(false);

  const [changeOrder, setChangeOrder] = React.useState(false);
  const [orderedIds, setOrderedIds] = React.useState([]);
  const [editState, setEditState] = React.useState(false);
  const [idToDelete, setIdToDelete] = React.useState(undefined); //this is to save the id to delete, and also open/close the delete modal
  const [refresh, setRefresh] = React.useState(false);
  const [override, setOverride] = React.useState(false);
  // function to reorder the list of accountabilities
  const saveReorder = () => {
    if (orderedIds.length > 0) {
      let orderedItems = [...state];
      orderedItems.sort((a, b) => {
        const indexA = orderedIds.indexOf(a._id);
        const indexB = orderedIds.indexOf(b._id);
        return indexA - indexB;
      });
      submit(
        `/actions/daily-accountability/add-athlete-accountability/${athlete._id}`,
        {
          method: "POST",
          body: {
            list: orderedItems,
            userToRequest: userToLoadInformation._id,
          },
        }
      );
      setState(orderedItems);
    }

    setChangeOrder(false);
  };

  const cancelReorder = () => {
    setChangeOrder(false);
    setOrderedIds([]);
    setRefresh(!refresh);
  };

  const addItem = () => {
    setAdding(true);
    const newState = state.map((item) => {
      return { ...item, editing: false };
    });
    setState([...newState, newItem]);
  };
  const cancelChanges = () => {
    setEditState(false);
    setAdding(false);
    setState(
      // In case of an organization, the userToLoadInformation should be the organization owner,
      // cause templates are stored at that level
      getAccountabilitiesList(
        organizationOwner || userToLoadInformation,
        athlete
      )
    );
  };
  const handleEditing = (i) => {
    setState(
      state.map((item, index) => {
        return i === index
          ? { ...item, editing: !item.editing }
          : { ...item, editing: false };
      })
    );
  };
  const saveChanges = () => {
    setEditState(false);
    return submit(
      `/actions/daily-accountability/add-athlete-accountability/${athlete._id}${
        athleteSwitch ? "?athleteSwitch=true" : ""
      }`,
      {
        method: "POST",
        body: {
          list: state.map((item) => filterAccountabilityAttrs(item)),
          userToRequest: userToLoadInformation._id,
        },
      }
    );
  };
  const removeItem = (id) => {
    setIdToDelete(id); // opening the modal sending the id to delete
  };

  const handleCancelDelete = () => {
    setIdToDelete(undefined);
  };

  const handleConfirmDelete = () => {
    const newState = state.filter((item, i) => i !== idToDelete);
    setState(newState);
    if (newState.length === 0) {
      return submit(
        `/actions/daily-accountability/remove-accountabilities/${athlete._id}${
          athleteSwitch ? "?athleteSwitch=true" : ""
        }`,
        {
          method: "POST",
          body: { userToRequest: userToLoadInformation._id },
        }
      );
    }
    submit(
      `/actions/daily-accountability/update-athlete-accountability/${
        athlete._id
      }${athleteSwitch ? "?athleteSwitch=true" : ""}`,
      {
        method: "POST",
        body: {
          list: newState.map((item) => filterAccountabilityAttrs(item)),
          userToRequest: userToLoadInformation._id,
        },
      }
    );
    setIdToDelete(undefined);
  };
  const handleOverride = () => {
    setState([]);
    setOverride(false);
    submit(
      `/actions/daily-accountability/remove-accountabilities/${athlete._id}${
        athleteSwitch ? "?athleteSwitch=true" : ""
      }`,
      {
        method: "POST",
        body: { userToRequest: userToLoadInformation._id },
      }
    );
  };
  const athleteAccountabilities = React.useMemo(() => {
    // In case of an organization, the userToLoadInformation should be the organization owner,
    // cause templates are stored at that level
    return getAccountabilitiesList(
      organizationOwner || userToLoadInformation,
      athlete
    );
  }, [userToLoadInformation, athlete]);

  React.useEffect(() => {
    compareArrays(athleteAccountabilities, state)
      ? setChanged(true)
      : setChanged(false);
    if (
      (adding && isItemFilled(state[state.length - 1])) ||
      isStateFilled(state)
    )
      setCanSubmit(true);
    else setCanSubmit(false);
    if (isEditing(state)) setEditState(true);
    else setEditState(false);
  }, [athlete, state]);

  React.useEffect(() => {
    setState(athleteAccountabilities);
  }, [athlete]);
  React.useEffect(() => {
    if (document.querySelector(".principal-grabber-div")) {
      scriptLoader(
        "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js",
        () => {
          const dragImage = document.createElement("img");
          dragImage.src =
            "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
          const sortable = new Sortable(
            document.querySelector(".principal-grabber-div"),
            {
              animation: 350,
              handle: ".drag-handle",
              setData(dataTransfer) {
                dataTransfer.setDragImage(dragImage, 0, 0);
              },
              onEnd: (e) => {
                if (e.oldIndex === e.newIndex) return;

                const newOrderedIds = Array.from(
                  document.querySelectorAll(".item-grabber-container")
                ).map((item) => item.id);

                setOrderedIds(newOrderedIds);
              },
            }
          );
        }
      );
    }
  }, []);
  return (
    <div role="accountability-wrapper">
      <header>
        <div>
          <div>
            <h4>Daily Accountability</h4>
            {/* tooltip for mobile */}
            <ToolTip
              id={"accountability-tooltip"}
              body={"Visit MSB University for a tutorial video on this feature"}
              childrenContainerClass="tooltip-coach"
            >
              <SvgIcon
                alt="info icon"
                src="/img/new-icons/question-circle.svg"
              />
            </ToolTip>
          </div>

          <div>
            <p className="p5">
              Create a list of habits and assign to days of the week for your{" "}
              {referAsClients ? "client's" : "athlete's"} to stay accountable
            </p>
          </div>
        </div>
        {state?.length === 0 ? (
          <hgroup>
            <a
              role="button"
              data-button-type="secondary"
              href="/actions/refresh?modal[type]=accountability-templates"
            >
              Template
            </a>
          </hgroup>
        ) : (
          <hgroup>
            {!changeOrder && !customAccountability && (
              <button
                data-button-type="secondary"
                onClick={
                  !editState
                    ? () => {
                        setChangeOrder(!changeOrder);
                      }
                    : null
                }
              >
                Change Order
              </button>
            )}
            {changeOrder && !customAccountability && (
              <button
                onClick={cancelReorder}
                data-button-type="secondary"
                data-action="cancel"
              >
                Cancel
              </button>
            )}
            {changeOrder && !customAccountability && (
              <button
                onClick={saveReorder}
                data-button-type="primary"
                disabled={orderedIds.length === 0}
              >
                Save
              </button>
            )}
            {!changeOrder && !customAccountability && (
              <a
                role="button"
                data-button-type="secondary"
                href="/actions/refresh?modal[type]=accountability-templates"
              >
                Template
              </a>
            )}
            {!changeOrder && (
              <a
                data-button-type="primary"
                role="button"
                href={
                  organizationCoach
                    ? `/athlete-portal/metrics/accountability?date=${moment().format(
                        "YYYYMMDD"
                      )}&athlete=${
                        athlete._id
                      }&organizationCoach=${organizationCoach}`
                    : `/athlete-portal/metrics/accountability?date=${moment().format(
                        "YYYYMMDD"
                      )}&athlete=${athlete._id}`
                }
              >
                View Report
              </a>
            )}
          </hgroup>
        )}
      </header>
      <ul>
        <div className="principal-grabber-div">
          {!customAccountability &&
            state?.length > 0 &&
            state.map((item, i) => (
              <AccountabilityCard
                hey
                key={`${item._id}${refresh}`}
                propState={athlete.accountability?.accountabilities || []}
                athleteId={athlete._id}
                state={state}
                id={i}
                setState={setState}
                changeOrder={changeOrder}
                editing={item.editing || false}
                adding={item.adding || false}
                handleEditing={handleEditing}
                removeItem={removeItem}
              />
            ))}
          <ConfirmationModal
            isOpen={idToDelete !== undefined}
            title="Delete Accountability"
            contentText={`Are you sure you want to delete this Accountability? \n If you delete it, you won’t be able to recover the Accountability back.`}
            cancelButtonText="Cancel"
            cancelButtonAction={handleCancelDelete}
            confirmButtonText="Delete"
            confirmButtonAction={handleConfirmDelete}
            icon="delete"
          />
        </div>
      </ul>
      {!customAccountability && state?.length > 0 && (
        <footer>
          {canSubmit && !changeOrder && !changed && (
            <button data-button-type="outline" onClick={addItem}>
              Add
            </button>
          )}
          <div>
            {(changed || editState) && (
              <button
                onClick={cancelChanges}
                data-button-type="secondary"
                data-action="cancel"
              >
                Cancel
              </button>
            )}
            {changed && canSubmit && (
              <button
                onClick={canSubmit ? saveChanges : null}
                data-button-type="primary"
                // className={canSubmit ? "acc-btn save" : "acc-btn "}
              >
                Save
              </button>
            )}
          </div>
        </footer>
      )}

      {(state?.length === 0 || customAccountability) && (
        <div className="no-accountabilities-assigned">
          <h4>
            {customAccountability
              ? "Custom accountabilities assigned"
              : "No accountabilities assigned"}
          </h4>
          <p className="p5">
            {customAccountability
              ? `Your ${
                  referAsClients ? "client" : "athlete"
                } has assigned accountabilities on their own, you can override them by clicking the button below`
              : "Create or assign a template to schedule daily accountabilities"}
          </p>

          {customAccountability ? (
            <div>
              <button
                data-button-type="secondary"
                onClick={() => setOverride(true)}
              >
                Override accountabilities
              </button>
              <ConfirmationModal
                isOpen={override}
                title="Override Accountability"
                contentText={`Are you sure you want to override your ${
                  referAsClients ? "client's" : "athlete's"
                } accountabilities?`}
                cancelButtonText="Cancel"
                cancelButtonAction={() => setOverride(false)}
                confirmButtonText="Override"
                confirmButtonAction={handleOverride}
                icon="delete"
              />
            </div>
          ) : (
            <div>
              <a
                role="button"
                data-button-type="primary"
                href="/actions/refresh?modal[type]=accountability-templates"
              >
                Assign Template
              </a>
              <button data-button-type="secondary" onClick={addItem}>
                Create New
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Accountability;
